import React from 'react'
import PropTypes from 'prop-types'

import FieldRAG_Icon from "./rag-icon"
import Pill from "../../../../gd-components/molecules/pill/pill";

export default function FieldRag_OptionPill(props:any) {

    if (!props.option) return null

    const onClick = (e:React.SyntheticEvent) => {
        // e.stopPropagation()
        if(props.onClick) props.onClick(props.option)
    }

    const onDelete = (e:React.SyntheticEvent) => {
        // e.stopPropagation()
        if(props.onDelete) props.onDelete(props.option)
    }

    return (
        <Pill className = "m-t-4 m-b-4 m-r-4"
              size      = "26"
              label     = {props.option.label}
              onDelete  = {onDelete}
              onClick   = {onClick} >
            <FieldRAG_Icon className="fl-ac fl-no-shrink m-r-8" option={props.option}/>
        </Pill>
    )

    // const pillClasses = Classes("ui5-pillbox default-color fl-ac m-t-4 m-b-4 m-r-4", "s{0}".f(props.size), props.className)
    //
    // return (
    //     <div className={pillClasses} style={props.style} onClick={props.onClick ? onClick : undefined}>
    //         <FieldRAG_Icon className="fl-ac fl-no-shrink m-r-8" option={props.option}/>
    //         <div className="ui5-txt-default txt-truncate">{props.option.label}</div>
    //
    //         {props.onDelete && <div className="delete-button ui5-ico-delete s14 gray m-t-5" onClick={onDelete}/>}
    //     </div>
    // );
}

FieldRag_OptionPill.propTypes = {
    size    : PropTypes.oneOf(['26', '22']),
    option  : PropTypes.object,

    onClick : PropTypes.func,
    onDelete: PropTypes.func
}

FieldRag_OptionPill.defaultProps = {
    size    : '26'
}
